/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Registry_House_NumbersInputs */

const cs_property_registry_house_numbers = /** @type {(inputs: Property_Registry_House_NumbersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Č. popisná`)
};

const en_property_registry_house_numbers = /** @type {(inputs: Property_Registry_House_NumbersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`House nos.`)
};

/**
* | output |
* | --- |
* | "House nos." |
*
* @param {Property_Registry_House_NumbersInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_registry_house_numbers = /** @type {((inputs?: Property_Registry_House_NumbersInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Registry_House_NumbersInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_registry_house_numbers(inputs)
	return cs_property_registry_house_numbers(inputs)
});